import { useEffect } from "react";
import { useTranslation } from "../context/LanguageContext";
import { useUserContext } from "../context/UserContext";
import { patchUser } from "../services/UserService";

// Reports the language the site is showing so email goes out in it (the server
// only knows what a client tells it). One PATCH per account+language per page
// load; a server that predates the field rejects it, which is harmless.
let attempted = "";

export default function LanguageSync() {
  const { user } = useUserContext();
  const { currentLanguage } = useTranslation();

  useEffect(() => {
    if (!user?.userId || user.language === currentLanguage) return;
    const key = `${user.userId}:${currentLanguage}`;
    if (attempted === key) return;
    attempted = key;
    patchUser({ language: currentLanguage }).catch((err) => {
      console.warn("Language sync failed:", err);
    });
  }, [user?.userId, user?.language, currentLanguage]);

  return null;
}
